import { post } from '@/lib/api/client'
import {
  NewsletterSubscribeRequestSchema,
  type NewsletterSubscribeRequest,
  type NewsletterSubscription,
  type ApiResponse
} from '@/lib/api/types'

export class NewsletterService {
  /**
   * Subscribe to newsletter (Public endpoint)
   * POST /newsletter/public/subscribe
   */
  async subscribe(
    data: NewsletterSubscribeRequest
  ): Promise<ApiResponse<NewsletterSubscription>> {
    const validatedData = NewsletterSubscribeRequestSchema.parse(data)

    return await post<ApiResponse<NewsletterSubscription>>(
      'newsletter/public/subscribe',
      validatedData
    )
  }
}

// Export singleton instance
export const newsletterService = new NewsletterService()

// Export default
export default newsletterService

